<template>
<div class="page">
    <div class="loading-screen" v-if="status=='LOADING'">
        <div>
            <span class="spinner spinner--lg"></span>
            <span>loading exams…</span>
        </div>
    </div>

    <div v-if="status=='LOADED'">
        <ExaminerNavBar/>
        <div class="container">
            <div class="page-head rise">
                <h1>All Assessments</h1>
                <p>Every exam on the platform — schedule, roster, and submissions.</p>
            </div>

            <div v-if="assesments.length == 0" class="glass empty-state rise">
                <div class="empty-state__icon">📭</div>
                <h2>No exams yet</h2>
                <p>Create your first assessment to get started.</p>
                <a class="btn btn--primary" href="/addexam">＋ New Exam</a>
            </div>

            <div v-else>
                <div v-for="(assesment, idx) in assesments" :key="assesment._id"
                     class="glass card card--hover mb-3 rise" :class="`rise-${Math.min(idx+1,4)}`">
                    <span class="card__meta">exam {{String(assesments.indexOf(assesment)+1).padStart(2,'0')}}</span>
                    <h2 class="card__title mt-2">{{assesment.name}}</h2>
                    <div class="flex gap-2 flex-wrap mt-2">
                        <span class="chip">📅 {{assesment.date.date}} {{getMonth(assesment.date.month)}} {{assesment.date.year}}</span>
                        <span class="chip">🕐 {{assesment.startTime.hours>9?assesment.startTime.hours:'0'+assesment.startTime.hours}}:{{assesment.startTime.minutes>9?assesment.startTime.minutes:'0'+assesment.startTime.minutes}}
                            — {{assesment.endTime.hours>9?assesment.endTime.hours:'0'+assesment.endTime.hours}}:{{assesment.endTime.minutes>9?assesment.endTime.minutes:'0'+assesment.endTime.minutes}}</span>
                    </div>
                    <div class="mt-3">
                        <span class="card__meta">examinees</span>
                        <div class="flex gap-2 flex-wrap mt-2">
                            <span class="chip" v-for="examinee in assesment.examinees" :key="examinee._id">👤 {{examinee.name}}</span>
                            <span class="text-dim" v-if="!assesment.examinees.length" style="font-size:0.85rem">none assigned</span>
                        </div>
                    </div>
                    <div class="mt-3">
                        <span class="card__meta">questions</span>
                        <div class="flex gap-2 flex-wrap mt-2">
                            <span class="chip chip--alt"
                                  v-for="question in assesment.questions" :key="question._id">⌘ {{question.name}}</span>
                            <span class="text-dim" v-if="!assesment.questions.length" style="font-size:0.85rem">none</span>
                        </div>
                    </div>
                    <div class="flex gap-2 mt-4">
                        <a class="btn btn--ghost btn--sm" :href="`/usersubmittions/${assesment._id}`">📥 View Submissions</a>
                        <button class="btn btn--danger btn--sm" @click="deleteAssesment(assesment._id)"
                                :disabled="deleteStatus.status=='LOADING' && deleteStatus.id==assesment._id">
                            <span class="spinner" v-if="deleteStatus.status=='LOADING' && deleteStatus.id==assesment._id"></span>
                            <span v-else>Delete Exam</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>
<script>
import {getAllAssesments, deleteAssesment} from '../services/assesments';
import Vue from 'vue';
import ExaminerNavBar from './ExaminerNavBar.vue';
export default {
    name: "AllAssesmentsPage",
    data() {
        return {
            status: 'LOADING',
            deleteStatus: {
                id: '',
                status: ''
            },
            error: "",
            assesments: this.getAllassesments(),
            isLoaded: null,
        };
    },
    methods: {
        async getAllassesments() {
            this.status='LOADING';
            try {
                const response = await getAllAssesments();
                this.assesments = response.data;
                for (let i in this.assesments)
                this.assesments[i] = {
                    ...this.assesments[i],
                    usersSubmition: []
                }

                this.status = "LOADED";
            }
            catch (error) {
                this.status = "ERROR";
                this.error = error.message;
            }
        },
        async deleteAssesment(examId) {
            try{
                    this.deleteStatus.status = 'LOADING';
                    this.deleteStatus.id = examId;
                    const response = await deleteAssesment(examId);
                    Vue.$toast.success('Assesment - '+response.data.name +' Deleted Successfully');

                } catch(error){
                    Vue.$toast.error(error.message);
                }
            this.deleteStatus.status = 'LOADED';
            await this.getAllassesments();
        },
        getMonth (month) {
            let monthArray = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
            return monthArray[month-1];
        },
    },
    components: {
        ExaminerNavBar
        },
}
</script>
